import { createContext, FC, ReactNode, useMemo, useState } from "react";
import { useLocalStorage } from "usehooks-ts";

const AppContext = createContext<any>({} as any);

const AppProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isModalTurnedOff, setIsModalTurnedOff] = useLocalStorage(
    "isModalTurnedOff",
    false
  );
  const [isModalOpen, setIsModalOpen] = useState<boolean>(!isModalTurnedOff);

  const value = useMemo(
    () => ({
      isModalTurnedOff,
      setIsModalTurnedOff,
      isModalOpen,
      setIsModalOpen,
    }),
    [isModalTurnedOff, setIsModalTurnedOff, isModalOpen, setIsModalOpen]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export { AppProvider, AppContext };
